import Component from '@glimmer/component';
import { ActionType } from 'common/enums/action-type.enum';
import type ActionModel from 'frontend/models/action';

export interface FormationPartsActionsDateArgs {
  model?: ActionModel[];
}

export default class FormationPartsActionsDate extends Component<FormationPartsActionsDateArgs> {
  get actionsPlannedAndConfirmed() {
    if (!this.args.model) return [];
    return this.args.model
      .filter(
        (action) =>
          action.type === ActionType.Planned ||
          action.type === ActionType.Confirmed
      )
      .sort(
        (a, b) => new Date(a.startAt).getTime() - new Date(b.startAt).getTime()
      );
  }

  get actionsPlannedAndConfirmedSize() {
    return this.actionsPlannedAndConfirmed.length;
  }

  get firstPlannedAction() {
    if (!this.actionsPlannedAndConfirmed) return undefined;
    return this.actionsPlannedAndConfirmed[0];
  }

  get firstVirtualAction() {
    if (!this.args.model) return undefined;
    return this.args.model.filter(
      (action) => action.type === ActionType.Virtual
    )[0];
  }

  get shouldShowNextPlanningButton() {
    return this.actionsPlannedAndConfirmed.length === 0;
  }
}
